import type { IEservicesGroupModule } from '../types/eservices';

interface GetFilterEServicesModulesParams {
  allModules: IEservicesGroupModule[];
  filterValue?: string;
  isPopularModule?: boolean;
}

const getFilterEServicesModules = ({
  allModules,
  filterValue = '',
  isPopularModule = false,
}: GetFilterEServicesModulesParams) => {
  const filterModules = allModules.filter(
    ({ description, isPopular, label, searchTags }) =>
      (label.toLowerCase().includes(filterValue.toLowerCase()) ||
        description.toLowerCase().includes(filterValue.toLowerCase()) ||
        searchTags?.some((tag) => tag.toLowerCase().includes(filterValue.toLowerCase()))) &&
      (!isPopularModule || !!isPopularModule === !!isPopular)
  );

  const uniqueModules = Array.from(new Map(filterModules.map((module) => [module.label, module])).values());

  return uniqueModules;
};

export { getFilterEServicesModules };
